<template>
  <div class="power-analysis" v-loading="lockStatus" element-loading-text="数据加载中......" element-loading-spinner="el-icon-loading">
    <div class="top-box">
      <span>分部：</span>
      <el-select v-model="factoryId" placeholder="请选择" class="id-select" @change="changeFactory">
        <el-option v-for="item in factoryOptions" :key="item.id" :label="item.divisionName" :value="item.id">
        </el-option>
      </el-select>
      <span>选择时间：</span>
      <button class="default" v-for="item in timeType" :key="item.id" :class="{ primary: item.selected }" @click="selectTimeType(item)">
        {{ item.name }}
      </button>
      <span class="choose-date">选择日期：</span>
      <el-date-picker class="select-date" :type="dateType" :value-format="dateFormat" placeholder="选择日期" v-model="selectedDate" :picker-options="pickerOptions" :clearable='false' @change="changeDate">
      </el-date-picker>
      <div class="fr">
        <button class="default" v-for="item in powerType" :key="item.id" :class="{ primary: item.selected }" @click="selectPowerType(item)">
          {{ item.categoryTreeName }}
        </button>
      </div>
    </div>
    <el-row :gutter="5" class="bottom-box">
      <el-col :xs="7" :md="7">
        <corner-box>
          <div class="box-element">
            <div class="box-title">总能耗</div>
            <div class="pie-title">
              <div class="note fl">
                <span>*</span>点击饼图，可查看对应下级分类详情
              </div>
              <div class="iconfont back-btn fl"  @click="goBack()" v-if="clickNo > 0">&#xe735;</div>
              <div class="fr tool-box">
                <el-button @click="download({title:'总能耗',selector:'#pieChart'})">下载</el-button>
                <el-button @click="print({title:'总能耗',selector:'#pieChart'})">打印</el-button>
              </div>
            </div>
            <div class="pie-chart" id="pieChart"></div>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="10" :md="10">
        <corner-box>
          <div class="box-element">
            <div class="box-title">{{modelName}}</div>
            <div id="ht-wrap"></div>
            <div class="tip" v-if="selectedPowerType=== '2'">注：建筑亮度与用能占比成正比</div>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="7" :md="7">
        <corner-box>
          <div class="box-element">
            <el-table class="energy-table" :data="tableData" stripe  @cell-mouse-enter="tableOver" @cell-mouse-leave="tableOut">
              <el-table-column prop="categoryTitle" :label="tableHeader[0]"></el-table-column>
              <el-table-column prop="currentDateValue" :label="tableHeader[1]"></el-table-column>
              <el-table-column prop="categoryRatetoall" :label="tableHeader[2]" ></el-table-column>
              <el-table-column prop="beforeDateValue" :label="tableHeader[3]" ></el-table-column>
              <el-table-column prop="circularRate" :label="tableHeader[4]" ></el-table-column>
            </el-table>
          </div>
        </corner-box>
      </el-col>
    </el-row>
    <el-row :gutter="5" class="bottom-box">
      <el-col :xs="12" :md="12">
        <corner-box>
          <div class="box-element">
            <div class="box-title">能耗环比</div>
            <div class="tool-box">
              <el-button @click="download({title:'能耗环比',selector:'#barChart'})">下载</el-button>
              <el-button @click="print({title:'能耗环比',selector:'#barChart'})">打印</el-button>
            </div>
            <div class="bar-chart " id="barChart"></div>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="12" :md="12">
        <corner-box>
          <div class="box-element">
            <div class="box-title">{{ lineTitle }}</div>
            <el-select class="transformer-select w140" v-model="transformerId" placeholder="请选择" v-if="selectedPowerType === '3'" @change="getLoadData">
              <el-option v-for="item in transformerOptions" :key="item.name" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
            <div class="tool-box">
              <el-button @click="download({title: lineTitle ,selector:'#lineChart'})">下载</el-button>
              <el-button @click="print({title:lineTitle ,selector:'#lineChart'})">打印</el-button>
            </div>
            <div class="line-chart" id="lineChart"></div>
            <div class="tips" v-if="selectedPowerType === '3'">
              <p>有功功率：{{activePower}}KW</p>
              <p>无功功率：{{reactivePower}}KW</p>
              <p>电压等级：{{voltageLevel}}</p>
            </div>
          </div>
        </corner-box>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import cornerBox from "../../components/cornerBox";
import {getNowFormatDate} from "../../assets/js/tools/time.js"
import {addResize,removeResize} from "../../assets/js/tools/echartsResize"
var echarts = require('echarts');

export default {
  name: "energyConsumptionAnalysis",
  data() {
    return {
      isGoNext: true,
      isNotAdd: true,
      hasDone: false,
      notGet: true,
      choosedModel: '',
      modelImage: [],
      levels: [],
      isClick: false,
      parentId: "0",
      clickNo: 0,
      lockStatus: "",
      factoryOptions: [],
      factoryId: "1",
      factoryName: "",
      matchTag: [],
      modelName: "",
      modelNum: 0,
      stepValue: 0,
      selectedTimeType: "day",
      selectedPowerType: "2",
      dateType: "date",
      dateFormat: "yyyy-MM-dd",
      selectedDate: "",
      lineTitle: "能耗环比",
      Url: "electricityAnalysis",
      tableHeader: ["类型","当日用电量(kW·h)","占比(%)","昨日用电量(kW·h)","环比(%)"],
      tableData:[],
      xUnit: "h",
      activePower: "",
      reactivePower: "",
      voltageLevel: "",
      pieChart: "",
      barChart: "",
      lineChart: "",
      timeType: [
        { id: 1, name: "日", value: "day", selected: true ,unit: "h",dateType: "date" , dateFormat: "yyyy-MM-dd"},
        { id: 2, name: "月", value: "month", selected: false,unit: "d" , dateType: "month" , dateFormat: "yyyy-MM"},
        { id: 3, name: "年", value: "year", selected: false, unit: "m", dateType: "year" , dateFormat: "yyyy"},
      ],
      powerType: [],
      transformerId: "0",
      transformerOptions: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  components: {
    cornerBox
  },
  beforeCreate() {
    window.htUrl('miniPark');
  },
  mounted() {
    this.selectedDate = this.defaultDate("date");
    this.getData();
    this.addGraphView();
  },
  beforeDestroy(){
    removeResize(this.pieChart)
    removeResize(this.barChart)
    removeResize(this.lineChart)
  },
  methods: {
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      this.g3d = new ht.graph3d.Graph3dView();         //3d
      this.g3d.addToDOM(document.getElementById('ht-wrap'));
      this.graphView.addToDOM(this.g3d.getView());
      let _this = this;
      this.g3d.deserialize('scenes/park.json', function (json, dm, g3d, datas) {
        /*_this.g3d.setEye(260, 2756, 1041);
        _this.g3d.setCenter(977, 882, 2248);*/
        _this.g3d.setFar(1000000);
      })
    },
    changeFactory() {
      this.getData();
    },
    selectTimeType(item) {
      this.timeType.forEach(function (i) {
        i.selected = false;
      });
      item.selected = true;
      this.selectedTimeType = item.value;
      this.xUnit = item.unit;
      this.dateType = item.dateType;
      this.dateFormat = item.dateFormat;
      this.selectedDate = "";
      this.selectedDate = this.defaultDate(item.dateType);
      this.lockStatus = true;
      this.getData();
    },
    defaultDate(type) {
      let time = ""
      switch (type) {
        case "date":
          time = getNowFormatDate();
          break;
        case "month":
          time = getNowFormatDate("month");
          break;
        case "year":
          time = getNowFormatDate("year") + "";
          break;
      }
      return time;
    },
    changeDate() {
      this.lockStatus = true;
      this.getData();
    },
    selectPowerType(item) {
      this.powerType.forEach(function (i) {
        i.selected = false;
      });
      item.selected = true;
      this.selectedPowerType = item.id;
      if (item.id === "3") {
        this.lineTitle = "负载率曲线";
      } else {
        this.lineTitle = "能耗环比";
      }
      this.lockStatus = true;
      this.parentId = "0";
      this.clickNo = 0,
      this.levels = [],
      this.getData();
    },
    goBack() {
      console.log( this.levels)
      // let n = this.clickNo;
      this.parentId = this.levels[0];
      this.levels.pop();
      this.clickNo--;
      this.isGoNext = true;
      this.getData();
      if(this.clickNo === 0) {
        let model = this.g3d.dm().getDataByTag(this.choosedModel)
        if(model) {
          this.isClick = false;
          model.s('brightness', 1)
          model.s('wf.color', 'rgb(80,192,230)');
          model.s('body.color', 'rgb(80,192,230)');
          let texture = ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+this.choosedModel+'.json')
          texture.forEach((item, index) => {
            item.image = this.modelImage[index]
          })
        }
      }
    },
    setParams() {
      let params = [];
      params.divisionId = this.factoryId;
      params.categoryTypeId = this.selectedPowerType;
      params.parentCategoryIds = this.parentId;
      params.period = this.selectedTimeType;
      params.endDate = this.selectedDate;
      // params.frontEndUrl = 'energyConsumptionAnalysis'
      return params;
    },
    getData () {
      let $this = this;
      this.$get('energyconsumptionanalysis/energyanalysis' , this.setParams()).then(
        (response) => {
          this.lockStatus = false;
          $this.hasDone = true;
          $this.factoryOptions = response.divisionList;
          if( $this.notGet) {
            $this.powerType = response.categoryTypeList;
            for( let i in $this.powerType ) {
              $this.powerType[i].selected = false;
            }
            $this.powerType[1].selected = true;
            $this.notGet = false;
          }
          $this.factoryOptions.forEach((item) => {
            if(item.id === $this.factoryId) {
              $this.factoryName = item.divisionName
            }
          })
          if(!this.isClick) {
            $this.modelName = $this.factoryName
          }
          if(response.pieChart.length == 0) {
            $this.isGoNext = false;
            $this.$message({ showClose: true , message:"没有更多数据了哦" });
            return
          } else {
            $this.isGoNext = true;
          }
          console.log($this.isGoNext)
          let resPieChart = response.pieChart;
          resPieChart.sort(function(a,b){
            return b.power - a.power;
          })
          $this.modelNum = 0;
          for( let i in resPieChart ){
            let model = $this.g3d.dm().getDataByTag(resPieChart[i].categoryName);
            if( model ) {
              resPieChart[i].hasModel = true;
              $this.modelNum++;
            } else {
              resPieChart[i].hasModel = false;
            }
          }
          $this.stepValue = 0;
          if( $this.modelNum > 1) {
            $this.stepValue = 0.5/($this.modelNum - 1) ;
          }
          let num1 = 0;
          for( let i in resPieChart){
            if( resPieChart[i].hasModel ) {
              let num2 = 1.3 - $this.stepValue * num1;
              resPieChart[i].color = Math.round( num2 * 100) / 100;
              num1++;
            }
          }
          $this.fillPieChart(resPieChart);
          $this.tableHeader = response.tableContent.title;
          $this.tableData = response.tableContent.data;
          $this.fillBarChart(response.histogram);
          if(this.selectedPowerType !== '3'){
            $this.fillLineChart(response.histogram);
          }else{
            $this.getLoadData();
          }
        },
        (err) => {
          console.log(err);
          this.lockStatus = false;
        }
      )
    },
    getLoadData() {
      this.$get('energyconsumptionanalysis/ymdloadratecurvedata',[this.transformerId, this.selectedDate])
          .then((res)=>{
            this.transformerOptions = [];
            this.transformerId = res.checkedTransformer.assetNumber;
            for(let i in res.transformerList) {
              let transformerObj = {
                name: res.transformerList[i].transformerName,
                value: res.transformerList[i].assetNumber
              }
              this.transformerOptions.push(transformerObj)
            }
            if(this.transformerId === res.checkedTransformer.assetNumber) {
              this.activePower = res.checkedTransformer.p
              this.reactivePower = res.checkedTransformer.q
              this.voltageLevel = res.checkedTransformer.voltageLevel
            }
            this.fillLineChart2(res.loadRateCurveData);
          })
    },
    fillPieChart (data) {
      let $this = this;
      this.pieChart = echarts.init(document.getElementById("pieChart"));
      let pieData = [];
      for (let i in data) {
        let obj = {};
        obj.tag = data[i].categoryName;
        let name = data[i].categoryName;
        obj.name = name.indexOf(' ') != -1 ? name = name.split(' ')[0] + '\n' + name.split(' ')[1] : name;
        obj.value = data[i].power * 1;
        obj.id = data[i].id;
        if( data[i].color ){
          obj.color = data[i].color;
        }
        pieData.push(obj);
      }
      this.matchTag = pieData;
      this.pieChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} <br/>{a}: {c} ({d}%)",
        },
        legend: {
          type:'scroll',
          orient: 'vertical',
          right: 0,
          top: 20,
          icon: "circle",
          textStyle: {
            color: '#ccc',
          },
          formatter(name) {
          let sum = 0, percent = 0;
          for (let i in pieData) {
            sum += parseFloat(pieData[i].value);
          }
          for (var i in pieData) {
            if(sum !== 0 && pieData[i].name == name) {
              percent = Math.round(pieData[i].value/sum * 10000) / 100 + "";
              break;
            }
          }
          let arr = ['' + name + ":(" + percent + '%)']
          return arr.join('\n');
          },

        },
        series: [
          {
            name: "用电量(kW·h)",
            type: "pie",
            radius: ['60%', '90%'],
            center: ['35%', '50%'],
            // roseType: 'area',
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center',
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                }
              }
            },
            labelLine: {
              show: false,
            },
            data: pieData,
          },
        ],
      });
      addResize(this.pieChart)
      if($this.isNotAdd) {
        this.pieChart.off('click')
        this.pieChart.off('mouseover')
        this.pieChart.off('mouseout')
        this.pieChart.on('click', function (e) {
          let tagName = e.data.name
          if($this.clickNo === 0) {
            $this.choosedModel = tagName
          }
          let model = $this.g3d.dm().getDataByTag(tagName);
          $this.isNotAdd = false;
          if($this.isGoNext) {
            if($this.hasDone) {
              $this.hasDone = false;
              if(model) {
                $this.modelName = tagName;
                $this.isClick = true;
                model.s('brightness', e.data.color);
                model.s('wf.color', 'rgb(245,171,20)');
                model.s('body.color', 'rgb(245,171,20)');
                $this.modelImage = [];
                ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+tagName+'.json').forEach((item) => {
                  $this.modelImage.push(item.image)
                  item.image = ''
                })
              }
              $this.levels.push($this.parentId);
              $this.parentId = e.data.id;
              $this.getData();
              $this.clickNo++;
              console.log($this.clickNo)
            }
          } else {

            return

          }
        })
        this.pieChart.on('mouseover', function (e) {
          let tagName = e.data.name
          let model = $this.g3d.dm().getDataByTag(tagName);
          if(model) {
            $this.modelName = tagName;
            model.s('brightness', e.data.color)
            model.s('wf.color', 'rgb(245,171,20)');
            model.s('body.color', 'rgb(245,171,20)');
            $this.modelImage = [];
            ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+tagName+'.json').forEach((item) => {
              $this.modelImage.push(item.image)
              item.image = ''
            })
          }
        })
        this.pieChart.on('mouseout', function (e) {
          if(!$this.isClick) {
            let tagName = e.data.name
            $this.modelName = $this.factoryName;
            let model = $this.g3d.dm().getDataByTag(tagName);
            if(model) {
              model.s('brightness', 1)
              model.s('wf.color', 'rgb(80,192,230)');
              model.s('body.color', 'rgb(80,192,230)');
              let texture = ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+tagName+'.json')
              texture.forEach((item, index) => {
                item.image = $this.modelImage[index]
              })
            }
          }
        })
      }
    },
    tableOver(row) {
      let tagName = row.categoryTitle;
      let color2 = 1;
      for( let i in this.matchTag ){
        if ( this.matchTag[i].tag === tagName ){
          if( this.matchTag[i].color ) {
            color2 = this.matchTag[i].color;
          }
        }
      }
      let model = this.g3d.dm().getDataByTag(tagName);
      if(model) {
        this.modelName = tagName;
        model.s('brightness', color2)
        model.s('wf.color', 'rgb(245,171,20)');
        model.s('body.color', 'rgb(245,171,20)');
        this.modelImage = [];
        ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+tagName+'.json').forEach((item) => {
          this.modelImage.push(item.image)
          item.image = ''
        })
      }
    },
    tableOut(row) {
      let tagName = row.categoryTitle;
      this.modelName = this.factoryName;
      let model = this.g3d.dm().getDataByTag(tagName);
      if(model) {
        model.s('brightness', 1)
        model.s('wf.color', 'rgb(80,192,230)');
        model.s('body.color', 'rgb(80,192,230)');
        let texture = ht.Default.getShape3dModel('models/北自园区/高亮楼宇/'+tagName+'.json')
        texture.forEach((item, index) => {
          item.image = this.modelImage[index]
        })
      }
    },
    fillBarChart(data) {
      this.barChart = echarts.init(document.getElementById('barChart'));
      let dataX = data.powerEachX;
      let XData = [];
      for(let i in dataX) {
        XData.push(dataX[i])
      }
      this.barChart.setOption({
        legend: {
          icon: "circle",
          textStyle: {
            color: '#ccc',
          },
          right: "center",
          top: "12",
          data: [data.powerBeforeEachName,data.powerEachName]
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: XData,
          axisLabel: {
            textStyle: {
              color: '#ccc'
            }
          }
        },
        grid: {
          left: '2%',
          top: '15%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#ccc'
            }
          },
          splitLine:{
            lineStyle:{
              color: '#082E44'
            }
          }
        },
        dataZoom: [
          {
            type: 'inside'
          }
        ],
        series: [
          {
            name: data.powerBeforeEachName,
            type: 'bar',
            barWidth: 8,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#ff9275'},
                    {offset: 1, color: '#fd6d90'}
                  ]
                )
              }
            },
            data: data.powerBeforeEachY,
          },
          {
            name:  data.powerEachName,
            type: 'bar',
            barWidth: 8,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#39dcde'},
                    {offset: 1, color: '#49b4f0'}
                  ]
                )
              }
            },
            data: data.powerEachY
          }
        ]
      })
      addResize(this.barChart);
    },
    fillLineChart(data) {
      this.lineChart = echarts.init(document.getElementById("lineChart"));
      let dataX = data.powerEachX;
      let XData = [];
      for(let i in dataX) {
        XData.push(dataX[i])
      }
      this.lineChart.setOption({
        legend: {
          icon: "circle",
          textStyle: {
            color: "#ccc",
          },
          right: "center",
          top: "12",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: XData,
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
        },
        grid: {
         left: '2%',
          top: '15%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#082E44",
            },
          },
        },
        series: [
          {
            name: data.powerBeforeEachName,
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            data: data.powerBeforeEachY,
            itemStyle: {
              normal: {
                color: "#ef7184",
              },
            },
          },
          {
            name: data.powerEachName,
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            data: data.powerEachY,
            itemStyle: {
              normal: {
                color: "#39DCDE",
              },
            },
          },
        ],
      },true);
      addResize(this.lineChart)
    },
    fillLineChart2(data) {
      let todayEachName = '',beforeEachName = '',avg = '';
      if(this.selectedTimeType == 'day') {
        avg = '';
        todayEachName = '当日负载率';
        beforeEachName = '昨日负载率';
      } else if (this.selectedTimeType == 'month') {
        avg = '平均值'
        todayEachName = '当月负载率日';
        beforeEachName = '上月负载率日';
      } else if (this.selectedTimeType == 'year') {
        avg = '平均值'
        todayEachName = '当年负载率月';
        beforeEachName = '去年负载率月';
      }
      let lineChart = echarts.init(document.getElementById("lineChart"));
      let dataX = data.xAxis;
      let XData = [];
      for(let i in dataX) {
        XData.push(dataX[i])
      }
      lineChart.setOption({
        legend: {
          icon: "circle",
          textStyle: {
            color: "#ccc",
          },
          left: "155",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: XData,
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
        },
        grid: {
          left: 30,
          top: 50,
          right: 30,
          bottom: 40,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#082E44",
            },
          },
        },
        series: [
          {
            name: beforeEachName + avg + '(%)',
            type: "line",
            symbol: "none",
            data: data.before.avgData,
            itemStyle: {
              normal: {
                color: "#fd6d8f",
              },
            },
            markLine: {
              silent: true,
              symbol: 'none',
              label:{
                show:true,
                position: 'insideEndTop',
                formatter(par){
                  return beforeEachName + '均值(%)：'+par.value
                }
              },
              lineStyle: {
                color: '#fd7987',
                type: 'solid'
              },
              data:[
                {
                  yAxis:data.before.markingData ? data.before.markingData: "",
                }
              ]
            }
          },
          {
            name: todayEachName + avg + '(%)',
            type: "line",
            symbol: "none",
            data: data.current.avgData,
            itemStyle: {
              normal: {
                color: "#49b5f0",
              },
            },
            markLine: {
              silent: true,
              symbol: 'none',
              label:{
                show:true,
                position: 'insideEndBottom',
                formatter(par){
                  return todayEachName + '均值(%)：'+par.value
                }
              },
              lineStyle: {
                color: '#44c2ea',
                type: 'solid'
              },
              data:[
                {
                  yAxis:data.current.markingData ? data.current.markingData: "",
                }
              ]
            }
          },
          {
            name: data.before.minData ? beforeEachName + '最小值' + '(%)' : "",
            type: "line",
            symbol: "none",
            data: data.before.minData ? data.before.minData:[],
            itemStyle: {
              normal: {
                color: "#ff857f",
              },
            },
          },
          {
            name: data.before.maxData ? beforeEachName + '最大值' + '(%)' : "",
            type: "line",
            symbol: "none",
            data: data.before.maxData ? data.before.maxData:[],
            itemStyle: {
              normal: {
                color: "#ff9175",
              },
            },
          },
          {
            name: data.current.minData ? todayEachName + '最小值' + '(%)' : "",
            type: "line",
            symbol: "none",
            data: data.current.minData ? data.current.minData:[],
            itemStyle: {
              normal: {
                color: "#3ecfe3",
              },
            },
          },
          {
            name: data.current.maxData ? todayEachName + '最大值' + '(%)' : "",
            type: "line",
            symbol: "none",
            data: data.current.maxData ? data.current.maxData:[],
            itemStyle: {
              normal: {
                color: "#3adbdf",
              },
            },
          },
        ],
      },true);
    },
    print(option) {
      this.printHtml({'htmlTitle': option.title, 'selector': option.selector, 'type': 'canvas'});
    },
    download(option) {
      this.getPdf({'htmlTitle': option.title, 'selector': option.selector});
    },
  },
};
</script>

<style scoped lang="scss">
.power-analysis {
  padding: 5px 0;
  .top-box {
    padding: 5px;
    padding: 5px;
    margin: 0 10px;
    color: #fff;
    .id-select {
      margin-left: 4px;
      margin-right: 20px;

    }
    .choose-date {
      margin-left: 20px;
    }
    .select-date {
      width: 215px;
    }
  }
  .bottom-box {
    margin: 5px 0;
    padding: 0 10px;
    .box-element {
      overflow: hidden;
      position: relative;
      height: 350px;

      #ht-wrap{
        width: 100%;
        background: linear-gradient(0deg, rgba(4, 72, 120, 0.06), rgba(4, 72, 120, 0.64));
      }
      .tip {
        position: absolute;
        left: 10px;
        bottom: 10px;
        font-size: 14px;
        color:#8c8f92;
      }
      .pie-title {
        width: 100%;
        padding-left: 15px;
        overflow: hidden;
        .note {
          margin: 12px 0;
          line-height: 32px;
          color: #1384c5;
          span {
            color: #fd6d90;
          }
        }
        .back-btn {
          width: 75px;
          margin: 12px 0 12px 10px;
          line-height: 34px;
          text-align: center;
          color: #3deee7;
          cursor: pointer;
        }
      }
      .tool-box {
        position: absolute;
        top: 45px;
        right: 5px;
        z-index: 999;
      }
      .pie-chart {
        width: 100%;
        height: 210px;
      
      }
      .energy-table {
        margin: 3px auto;
        width: 99%;
        height: 350px;
      }
      .transformer-select {
        position: absolute;
        top: 45px;
        left: 5px;
        z-index: 999;
      }
      .tips {
        position: absolute;
        right: -38px;
        top: 80px;
        width: 180px;
        padding: 10px;
        color:#ccc;
      }
      .bar-chart {
        height: 320px;
        width:100%;
      }
      .line-chart {
        height: 320px;
        width:100%;
      }
    }
  }
  @media screen and (width:3440px) and (height: 1440px )   {
      .bottom-box{
        .box-element{
          height: 600px;
          overflow: auto;
       .pie-chart {
        width: 100%;
        height: 500px;
      
      }
      .bar-chart {
        height: 500px;
        width:100%;
      }
      .line-chart{
        height: 500px;
        width:100%;
      }
      .energy-table{
        height: auto;
      }
        }
      }
      
    }
    @media screen and (width:3840px) and (height: 1080px )   {
      .bottom-box{
        .box-element{
          height: 400px;
        }
      }
    }
}
</style>
